import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import "./education-last.css";

const EducationLast = ({ nextStep, prevStep }) => {
  return (
    <Box className='education-container'>
      <Box className='left-flower-character'>
        <img src='./CYPImages/WormisFlower.png' alt='left-flower character' className='left-flower-character-image' />
      </Box>
      <Box className='education-form-container'>
        {/* Title */}

        <Typography variant='h4' className='education-title' align='center' gutterBottom>
          Education
        </Typography>

        {/* Subtitle */}
        <Typography variant='body1' className='education-subtitle'>
          If you do not have a school, we will discuss with your social worker <br /> and agree on school options around
          the home. The Adults in the <br /> home are happy to engage you in <br />
          Some form of informal learning based on your interest.
        </Typography>
        <Box className='collection-box'>
          <img src='./CYPImages/collection.png' alt='Bottom Character' className='collection-image' />
        </Box>
        {/* Speech bubbles */}
        <Box className='speech-bubbles'>
          <Box className='bubble yellow-bubble'>
            We want to make sure you receive a good <br />
            education.
          </Box>
          <Box className='bubble red-bubble' ml={10}>
            All young people between the ages of 4 to 16 <br />
            must be in education
          </Box>
          <Box className='bubble green-bubble'>
            School helps you to learn develop friendships and <br /> social skills
          </Box>
          <Box className='bubble purple-bubble' ml={10}>
            If there is a reson you dont like school and
            <br /> dont wnat to go then you need to tell an
            <br /> adult so we can help support you.
          </Box>
        </Box>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box className='bottom-education' mr={3}>
        <img src='./CYPImages/WormisStayingHome.png' alt='Bottom Character' className='bottom-education-image' />
      </Box>
    </Box>
  );
};

export default EducationLast;
